import { getLastVisitedPage } from './saga';

import * as _actions from './actions.js';

export const actions = _actions;
export const getPage = getLastVisitedPage;